export default __webpack_public_path__ + "static/hackaday-ebbcb7416cc4f6d9fd2ba76fe6184901.svg";